import type { EpocusReview } from "$global-providers/rxdb-provider/collections/epocus-review";
import { Box, Chip, styled, Typography } from "@material-ui/core";
import { ChipRow, chipStyle } from "./epocus-chip";
import { EPOCUS_TEXT_PRIMARY, EPOCUS_WHITE, rem } from "./epocus-palette";
import { EpocusStarRating } from "./epocus-star-rating";
import { AGREEMENT_COLORS, AGREEMENT_LABELS } from "./review-agreement";
import { Card, MetaLabel } from "./stat-primitives";

const CardRoot = styled(Card)({
  display: "flex",
  flexDirection: "column",
  gap: 12,
});

const AgreementPill = styled(Typography)({
  alignSelf: "flex-start",
  padding: "5px 12px",
  borderRadius: 20,
  color: EPOCUS_WHITE,
  fontSize: rem(13),
  fontWeight: 700,
});

const CommentText = styled(Typography)({
  fontSize: rem(14),
  color: EPOCUS_TEXT_PRIMARY,
  lineHeight: 1.5,
  whiteSpace: "pre-wrap",
});

export const ReviewOutcomeCard: FC<{ review: EpocusReview }> = ({ review }) => (
  <CardRoot>
    <MetaLabel>QA review</MetaLabel>
    <AgreementPill
      style={{ backgroundColor: AGREEMENT_COLORS[review.agreement] }}
    >
      {AGREEMENT_LABELS[review.agreement]}
    </AgreementPill>
    <Box>
      <MetaLabel>Image quality</MetaLabel>
      <EpocusStarRating
        value={review.imageQualityScore ?? review.qualityScore}
        readOnly
      />
    </Box>
    {review.feedbackTags.length > 0 && (
      <Box>
        <MetaLabel>Feedback</MetaLabel>
        <ChipRow mt={1}>
          {review.feedbackTags.map((tag) => (
            <Chip
              key={tag}
              label={tag}
              variant="outlined"
              style={chipStyle(false)}
            />
          ))}
        </ChipRow>
      </Box>
    )}
    {review.comment && (
      <Box>
        <MetaLabel>Comment</MetaLabel>
        <CommentText>{review.comment}</CommentText>
      </Box>
    )}
  </CardRoot>
);
